/** @jsx h */
import SearchInput from '../SearchInput';

const SearchHeaderGlobal = ({
  query,
  pluginNamespace,
  triggerAjaxSubmit,
  resetFilters,
}) => {
  return (
    <div className="search-form__input">
      <SearchInput
        query={query}
        pluginNamespace={pluginNamespace}
        triggerAjaxSubmit={triggerAjaxSubmit}
        resetFilters={resetFilters}
      />
    </div>
  );
};

export default SearchHeaderGlobal;
